import React from 'react';
import { Link } from 'react-router-dom';
import NFimg from '../image/mariel404.png';

const Notfound = () => {
  return (
    <div>
        <div className='NFimgBOX'>
        <img className='NFimg' src={NFimg}/>
        </div>
        <div className='NF-box'>
        <a>{`앗! 잘못 찾아오신 것 같아요!\n아래 버튼을 눌러주시면 제가 돌려 보내드릴게요!`}</a>
        </div>
        <div className='BackToMainbox'>
        <button className='BackToMain'><Link to="/">다시 돌아가기</Link></button>
        </div>
    </div>
  )
}


export default Notfound;